import "./Home.scss";
import React, { useState, useEffect } from "react";
import AnimateLetters from "../../components/AnimateLetters";
import Particle from "../../components/Particle";
import { Link } from "react-router-dom";

export default function Home() {
  const [letterClass, setLetterClass] = useState("text-animate");
  const nameArray = [
    "I",
    "'",
    "m",
    " ",
    "R",
    "A",
    "H",
    "U",
    "L",
    " ",
    "G",
    "O",
    "O",
    "G",
    "I",
    "K",
    "O",
    "L",
    "L",
  ];
  // const pronounsArray = ['M','y',' ','p','r','o','n','o','u','n','s',' ','a','r','e',' ','t',' h ','e','y',' ','/',' ','t','h','e','m']
  const jobArray = [
    "J",
    "A",
    "V",
    "A",
    " ",
    "F",
    "u",
    "l",
    "l",
    "-",
    "S",
    "t",
    "a",
    "c",
    "k",
    " ",
    "D",
    "e",
    "v",
    "e",
    "l",
    "o",
    "p",
    "e",
    "r",
  ];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);
  }, []);

  return (
    <>
      <div className="container home-page" tabIndex="-1">
        <Particle />
        <div className="header-container">
          <h1>Hi,</h1>
          <h2 className="my-name">
            <AnimateLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
          </h2>
          <h3>
            <AnimateLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={15}
            />
          </h3>

          <Link to="/contact" className="flat-buttonn">
            CONTACT ME
          </Link>

          <a
            href="RAHUL RFD.pdf"
            download="RAHULRFD.pdf"
            className="flat-buttonn"
          >
            DOWNLOAD CV
          </a>
          {/* 
          <a>sadfasd</a>  */}
        </div>
      </div>
    </>
  );
}
